import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, setData } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data);
        if (data.profile) setData(data.profile);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.profile ? "/app/dashboard" : "/onboarding", { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6">
      <Logo size={44} />
      <Loader2 className="animate-spin text-neon" size={30} />
      <p className="text-sm text-[hsl(var(--muted-foreground))]">Connexion en cours…</p>
    </div>
  );
}
